

/* 호텔 생성 / 수정 */
$(".editHotelBtn").on("click", function(e){
    e.preventDefault();

    const data = $(this).data();

    let printImagePrint = "";

    $("#hotel_input_modal_title").html(data.title);

    $("#hotel_input_form").each(function(){
        this.reset();
    });

    $("#hotel_input_form select[name=display]").selectpicker('val', '');
    $("#hotel_input_form select[name=country]").selectpicker('val', '');
    $("#hotel_input_form select[name=rating]").selectpicker('val', '');

    $("#hotel_input_form input[name=_method]").val(data.method);
    $("#hotel_input_form input[name=id]").val('');

    $("#hotel_input_form").attr('action', "hotels" + ( data.method == 'PUT' ? "/" + data.json.id : '' ) );

    if( undefined !== data.json ) {

        $("#hotel_input_form select[name=display]").selectpicker('val', data.json.display);
        $("#hotel_input_form select[name=country]").selectpicker('val', data.json.country);
        $("#hotel_input_form select[name=rating]").selectpicker('val', data.json.rating);

        $("#hotel_input_form input[name=id]").val(data.json.id);
        $("#hotel_input_form input[name=koTitle]").val(data.json.koTitle);
        $("#hotel_input_form input[name=enTitle]").val(data.json.enTitle);
        $("#hotel_input_form input[name=addr]").val(data.json.addr);
        $("#hotel_input_form input[name=mapAddr]").val(data.json.mapAddr);
        $("#hotel_input_form input[name=tel]").val(data.json.tel);

        $("#hotel_input_form textarea[name=info1]").val(data.json.info1);
        $("#hotel_input_form textarea[name=info2]").val(data.json.info2);
        $("#hotel_input_form textarea[name=info3]").val(data.json.info3);
        $("#hotel_input_form textarea[name=info4]").val(data.json.info4);
        $("#hotel_input_form textarea[name=info5]").val(data.json.info5);

        // 지역 세팅
        subListChanged("#countryList", "#cityList");

        $("#hotel_input_form select[name=city]").val(data.json.city).prop("selected", true);

        // 호텔 상세 정보
        var hotel_info_Arr = JSON.parse(data.json.hotel_info);
        for (var hotel_info_i in hotel_info_Arr) {
            $("#hotel_input_form #hotel_info_" + hotel_info_Arr[hotel_info_i]).prop('checked', true);
        }


        /*var feesData = JSON.parse(data.json.fees);
        $("#hotel_input_form input[name=percent]").val(feesData.percent);
        $("#hotel_input_form select[name=money]").selectpicker('val', feesData.money);
        $("#hotel_input_form input[name=price]").val(feesData.price);
        feesSelect(feesData.fees);
        $("#hotel_input_form #fees_"+feesData.fees).prop('checked', true);*/


        // 이미지
        if (data.json.images) {
            let images = JSON.parse(data.json.images);
            //var images = data.json.images.split(',');
            let printImageSource = $("#editImages").val();
            for (var image_i in images) {
                var printImagesTmp = printImageSource;
                printImagesTmp = printImagesTmp.replace(/{--imgid--}/gi, image_i);
                printImagesTmp = printImagesTmp.replace(/{--image--}/gi, "/storage/" + images[image_i]);
                printImagePrint += printImagesTmp;
            }
        }

    }else{
        feesSelect('yield');
    }

    $('#hotel_input_form .selectpicker').selectpicker('refresh');

    $("#printImages").html(printImagePrint);

    $( "#printImages" ).sortable({
        placeholder: 'sortable_placeholder',
        update: function () {
            var sorted = $( "#printImages" ).sortable( "toArray" );
            $('#sortedImages').val(sorted);
        }
    });

});


/* 호텔 수수료 타입 변경 */
window.feesSelect = function ( value ){
    if ( 'yield' == value ) {
        $('.feesDIV').hide();
        $('.yieldDIV').show();
    }else{
        $('.yieldDIV').hide();
        $('.feesDIV').show();
    }
}












/* 룸 생성 / 수정 */
$(".editRoomBtn").on("click", function(e){
    e.preventDefault();

    const data = $(this).data();

    let printImagePrint = "";

    $("#room_input_modal_title").html(data.title);

    $("#room_input_form").each(function(){
        this.reset();
    });

    $('#hotelRoomDeleteBtn').hide();

    $("#room_input_form input[name=hotel]").val(data.hotel);
    $("#room_input_form input[name=room]").val(data.room);
    $("#room_input_form input[name=_method]").val(data.method);
    $("#room_input_form").attr('action', "hotelroom" + ( data.method=='PUT' ? '/'+data.room : '') );

    console.log(data.json);
    if( undefined !== data.json ) {

        $("#room_input_form input[name=title]").val(data.json.title);

        $("#room_input_form textarea[name=contents]").val(data.json.contents);

        //$("#room_input_form input[name=price]").val(number_format(data.json.price));
        //$("#room_input_form select[name=money]").val(data.json.money).prop("selected", true);

        $("#room_input_form input[name=maxpeople]").val(data.json.maxpeople);

        // 호텔 상세 정보
        var views_Arr = JSON.parse(data.json.views);
        for (var views_i in views_Arr) {
            $("#room_input_form #view_" + views_Arr[views_i]).prop('checked', true);
        }

        // 이미지
        if (data.json.images) {
            let images = JSON.parse(data.json.images);
            let printImageSource = $("#editImages").val();
            for (var image_i in images) {
                var printImagesTmp = printImageSource;
                printImagesTmp = printImagesTmp.replace(/{--imgid--}/gi, image_i);
                printImagesTmp = printImagesTmp.replace(/{--image--}/gi, "/storage/" + images[image_i]);
                printImagePrint += printImagesTmp;
            }
        }

        // 삭제버튼
        $('#hotelRoomDeleteBtn').show();
    }

    $('#room_input_form .selectpicker').selectpicker('refresh');

    $("#printRoomImages").html(printImagePrint);

    $( "#printRoomImages" ).sortable({
        placeholder: 'sortable_placeholder',
        update: function () {
            var sorted = $( "#printRoomImages" ).sortable( "toArray" );
            $('#sortedRoomImages').val(sorted);
        }
    });

});



/* 룸 삭제 */
$("#hotelRoomDeleteBtn").on("click", function(e){
    var form = $("#hotelRoomDelForm");
    var room = $("#room_input_form input[name=room]").val();
    if( isset(room) && confirm('정말 룸을 삭제 하시겠습니까?') ){
        form.attr('action', "hotelroom/" + room);
        form.submit();
    }
});










/* 새 시즌 생성 */
window.addSeason = function ( promotion ){
    $.ajax({
        type : 'POST',
        url : '/hotelsaeson/'+promotion,
        headers: {
            'X-CSRF-TOKEN': $ ( 'meta[name="csrf-token"]' ).attr ( 'content' )
        },
        success : function (data) {
            if ( data ) {
                location.reload();
            }
        }
    });
}

/* 시즌 삭제 */
window.delSeason = function ( season ){
    if ( confirm('삭제하시겠습니까?') ) {
        $.ajax({
            type: 'DELETE',
            url: '/hotelsaeson/' + season,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data) {
                    location.reload();
                }
            }
        });
    }
}



/* 시즌 날짜 생성 / 수정 */
$(".editSaesonDateBtn").on("click", function(e){
    e.preventDefault();

    var datas = $(this).data();

    $("#saeson_input_form").each(function(){
        this.reset();
    });

    $("#saeson_input_modal_title").html(datas.title);

    $("#saeson_input_form").attr('method',datas.method);


    if( isset(datas.json) && 'PUT' == datas.method ) {

        $("#saeson_input_form").attr('action', "hotelsaesondates/" + datas.json.id );
        $("#saeson_input_form input[name=title]").val(datas.json.title);
        $("#startDate").val(datas.json.startDate);
        $("#endDate").val(datas.json.endDate);

        $( "#notIncDates" ).empty();
        if( isset(datas.json.notIncDates) && datas.json.notIncDates !== undefined && datas.json.notIncDates !== "" ) {
            var notIncDatesList = JSON.parse(datas.json.notIncDates);
            for (date_i in notIncDatesList) {
                $("#notIncDates").append('<li><input type="hidden" name="notIncDates[]" value="' + notIncDatesList[date_i] + '">' + notIncDatesList[date_i] + '</li>');
            }
        }

        $('#hotelsaesonDatasDelBtn').show();

    }else{
        $("#saeson_input_form").attr('action', "hotelsaesondates/" + datas.saeson );
    }

    notIncDates();
});


/* 시즌날짜 저장 */
window.saveSaesonDate = function (){
    $.ajax({
        type : $("#saeson_input_form").attr('method'),
        url : $("#saeson_input_form").attr('action'),
        data : $("#saeson_input_form").serialize(),
        headers: {
            'X-CSRF-TOKEN': $ ( 'meta[name="csrf-token"]' ).attr ( 'content' )
        },
        success : function (data) {
            if ( data ) {
                location.reload();
            }
        }
    });
}


/* 시즌날짜 삭제 */
window.delSaesonDate = function (){
    if ( confirm('삭제하시겠습니까?') ) {
        $.ajax({
            type: 'DELETE',
            url: $("#saeson_input_form").attr('action'),
            data: $("#saeson_input_form").serialize(),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data) {
                    location.reload();
                }
            }
        });
    }
}



/*부킹불가날짜 달력*/
window.notIncDates = function(attrName = "notIncDates[]", datepickerTarget = "#multiDatesPicker", resultTargrt = "#notIncDates", startDateTarget = "#startDate", endDateTarget = "#endDate") {

    /* 초기화 */
    $ ( datepickerTarget ).multiDatesPicker ( 'destroy' );
    $ ( datepickerTarget ).multiDatesPicker ( 'resetDates', 'disabled' );

    var startDate = $(startDateTarget).val();
    var endDate = $(endDateTarget).val();

    /* 세팅된 날짜들 */
    var setDates = [];
    $( resultTargrt + " li input").each(function(){
        var selData = $(this).val();
        if( moment(selData) >= moment(startDate) ) {
            setDates.push(selData);
        }
    });

    /* 기간내 모든 날짜 */
    var allDates = [];
    var allStartDate = moment(startDate).startOf('day');
    var allEndDate = moment(endDate).startOf('day');
    while(allStartDate.add(1, 'days').diff(allEndDate) < 0) {
        allDates.push(allStartDate.toDate());
    }


    //setDates = $.unique(setDates);

    /* 세팅된 날짜들을 기간범위 내 조정  */
    $( resultTargrt ).empty();
    for ( var setDateI in setDates ){
        if( moment(setDates[setDateI]) >= moment(startDate) && moment(setDates[setDateI]) <= moment(endDate) ){
            $(resultTargrt).append('<li><input type="hidden" name="'+attrName+'" value="' + setDates[setDateI] + '">' + setDates[setDateI] + '</li>');
        }
    }

    /* 달력용 날짜 범위 계산 */
    var minmax = daysMinMax(startDate, endDate);

    $ ( datepickerTarget ).multiDatesPicker ( {
        numberOfMonths : 2,
        showButtonPanel: false,
        showOtherMonths: false,
        addDates       : setDates.length ? setDates : null,
        minDate        : minmax.min,
        maxDate        : minmax.max,
        onSelect       : function () {
            $( resultTargrt ).empty();
            var values = this.value;
            values = values.replace ( /\s/gi, "" );
            values = values.split ( ',' );
            for ( var i in values ){
                if(
                    moment(values[i]) >= moment(startDate)
                    &&
                    moment(values[i]) <= moment(endDate)
                ){
                    $(resultTargrt).append('<li><input type="hidden" name="'+attrName+'" value="' + values[i] + '">' + values[i] + '</li>');
                }
            }
        }
    } );
}



/*오늘기준 MIN / MAx date 날짜수 */
window.daysMinMax = function( start, end ) {
    let today = new Date();

    let sdate = $.datepicker.parseDate('yy-mm-dd', start);
    sdate     = sdate == null ? today : sdate;
    sdate     = sdate.getTime () - today.getTime ();
    sdate     = Math.ceil ( sdate / ( 1000 * 3600 * 24 ) );

    let eDate = $.datepicker.parseDate('yy-mm-dd', end);
    eDate     = eDate == null ? today : eDate;
    eDate     = eDate.getTime () - today.getTime ();
    eDate     = Math.ceil ( eDate / ( 1000 * 3600 * 24 ) );

    return { 'min': sdate, 'max': eDate };
}









/* 프로모션 그룹 생성/수정 */
$(".editPromotionBtn").on("click", function(e) {

    e.preventDefault();

    const datas = $(this).data();

    /* 초기화 */
    $("#promotionOptions").html("");
    $("#editPrmtOptAdd").removeClass("show");

    $("#promotion_input_form").each(function(){
        this.reset();
    });

    /* 삭제 버튼 초기화 */
    $('#hotelpromotionDeleteBtn').hide();

    $("#promotion_input_modal_title").html(datas.title);

    if( isset(datas.json) && 'PUT' == datas.method ) {

        /* 삭제 버튼 */
        $('#hotelpromotionDeleteBtn').show();

        $("#promotion_input_form").attr('action', "hotelpromotion/" + datas.promotion);

        $("#promotion_input_form textarea[name=include]").text(datas.json.include);
        $("#promotion_input_form textarea[name=check]").text(datas.json.check);

        $.ajax({
            type : 'POST',
            url : 'hotelpromotionoption/'+datas.promotion,
            headers: {
                'X-CSRF-TOKEN': $ ( 'meta[name="csrf-token"]' ).attr ( 'content' )
            },
            success : function (prmtList) {

                $("#promotionOptions").append(prmtList);

                $("#promotion_input_form").each(function(){
                    this.reset();
                });

                datepicker();

                $('.selectpicker').selectpicker();


            }
        });

        $('#editPromotion').modal();

    }else{

        if ( confirm('새로운 프로모션을 생성하시겠습니까?') ) {
            $.ajax({
                type: datas.method,
                url: 'hotelpromotion/' + datas.hotel,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (prmtData) {

                    $("#promotion_input_form").attr('action', "hotelpromotion/" + prmtData.id);

                    $('#editPromotion').modal();

                }
            });
        }
    }
});


/* 프로모션 그룹 저장 */
window.savePromotion = function (){
    $.ajax({
        type : 'PATCH',
        url : $("#promotion_input_form").attr('action'),
        data : $("#promotion_input_form").serialize(),
        headers: {
            'X-CSRF-TOKEN': $ ( 'meta[name="csrf-token"]' ).attr ( 'content' )
        },
        success : function (data) {
            if ( data ) {
                location.reload();
            }
        }
    });
}


/* 프로모션 그룹 삭제 */
window.deletePromotion = function (){
    if ( confirm('삭제하시겠습니까?') ) {
        $.ajax({
            type: 'DELETE',
            url: $("#promotion_input_form").attr('action'),
            data: $("#promotion_input_form").serialize(),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data) {
                    location.reload();
                }
            }
        });
    }
}



/* 프로모션 옵션 생성 */
$(".editPrmtOptBtn").on("click", function(e){
    e.preventDefault();

    const datas = $(this).data();

    $("#promotionContents").html("");

    $.ajax({
        type : 'POST',
        url : "hotelpromotion",
        data : {
            'templet' : datas.templet,
            'hotel' : datas.hotel,
        },
        headers: {
            'X-CSRF-TOKEN': $ ( 'meta[name="csrf-token"]' ).attr ( 'content' )
        },
        success : function (data) {

            if( data ){

                var optionID = Math.floor(Math.random()*1000000).toString();

                data = data.replace(/{--optionID--}/gi, optionID);
                data = data.replace(/{--optionCODE--}/gi, datas.code);
                data = data.replace(/{--optionNAME--}/gi, datas.name);

                data = data.replace(/{--optionDBID--}/gi, 0 );

                $("#promotionOptions").append(data);

                //$("#promotionContents").html(data);
                //$("#editPrmtOpt").modal();

                $("#promotion_option_input_form").each(function(){
                    this.reset();
                });

                datepicker();

                $('.selectpicker').selectpicker();


                $("#promotion_option_input_modal_title").html(datas.title);

                $("#promotion_option_input_form input[name=_method]").val(datas.method);

                //$("#mixRoom").selectpicker('val', '');


                if( isset(datas.json) && 'PUT' == datas.method ) {




                }else{

                    /* EarlyBird */
                    if( datas.templet == 'EarlyBird' ){
                        optEBTypeCheck('days', optionID);
                    }

                    $("#promotion_option_input_form").attr('action', "hotelpromotionoption/" + datas.promotion );

                    $('#hotelprmtOptDeleteForm').attr('action',"");
                    $('#hotelprmtOptDeleteBtn').hide();
                }

                /* Stay */
                if( datas.templet == 'Stay' ) {
                    $("#promotion_option_input_form input[name=type]").val(datas.code);
                    //optSvcTypes(datas.code);
                    $(".optSvcTypesFreeAdd_MS").hide();
                }

                /* Period */
                if( datas.templet == 'Period' ){
                    $("#promotion_option_input_form input[name=type]").val(datas.code);
                    //promotionPeriodType(datas.code);
                }

                //$( "#" + datas.templet + "_" + datas.code ).trigger("click");

            }
        }
    });


});




/* 프로모션 옵션 삭제 */
window.removePrmtOtn = function ( id, setType ){
    if ( confirm('삭제하시겠습니까?') ) {
        if ( setType == 'SET' ){
            $.ajax({
                type : 'DELETE',
                url : 'hotelpromotionoption/'+id,
                headers: {
                    'X-CSRF-TOKEN': $ ( 'meta[name="csrf-token"]' ).attr ( 'content' )
                },
                success : function (data) {
                    if (data){
                        $("#promotionOptions div#prmtOtn" + id).empty();
                    }
                }
            });
        }else{
            $("#promotionOptions div#prmtOtn" + id).empty();
        }
    }
}



/* 프로모션 - 얼리버트 타입 변경 */
window.optEBTypeCheck = function(optEBType,optionID){
    $(".optEBTypeDays_"+optionID).hide();
    $(".optEBTypeDate_"+optionID).hide();
    if( optEBType == 'date' ){
        $(".optEBTypeDate_"+optionID).show();
        $("#EbSetDate_"+optionID).attr('required', true);
        $("#EbStart_"+optionID).removeAttr('required');
        $("#EbEnd_"+optionID).removeAttr('required');
    }else{
        $(".optEBTypeDays_"+optionID).show();
        $("#EbStart_"+optionID).attr('required', true);
        $("#EbEnd_"+optionID).attr('required', true);
        $("#EbSetDate_"+optionID).removeAttr('required');
    }
};



/* 프로모션 - 시즌 시작일,종료일 변경 */
window.promotionChangeDate = function(){
    notIncDates("notIncDates[]", "#promotion_multiDatesPicker", "#promotion_notIncDates", "#promotion_startDate", "#promotion_endDate");
};



/* 프로모션 -  시즌형태 타입 변경 */
window.promotionPeriodType = function(value){
    $(".promotionPeriodTypeUpgrad").hide();
    if( value == 'RU' ){
        $(".promotionPeriodTypeUpgrad").show();
    }
};



/* 프로모션 -  연박 무료숙박 제공형태 변경 */
window.optSvcTypes = function(value){
    $(".optSvcTypesFreeAdd_FS").hide();
    /*if( value == 'FS' ){
        $(".optSvcTypesFreeAdd").show();
    }*/
};










/* 숙박형태 추가 버튼 */
$(".addStayTypeBtn").on("click", function(e) {
    var datas = $(this).data();
    $("#addStayTypes_form").attr('action','hotelstaytype/'+datas.promotion);
    $("#addStayTypes").modal();
});


/* 프로모션 숙박형태 생성(저장) */
window.addStayTypes = function () {
    $.ajax({
        type : 'POST',
        url : $("#addStayTypes_form").attr('action'),
        data : $("#addStayTypes_form").serialize(),
        headers: {
            'X-CSRF-TOKEN': $ ( 'meta[name="csrf-token"]' ).attr ( 'content' )
        },
        success : function (data) {
            if ( data ) {
                location.reload();
            }
        }
    });
}









/* 요금표 입력 모달 */
$(".editPriceBtn").on("click", function(e) {
    e.preventDefault();
    var datas = $(this).data();

    $("#price_input_modal_title").html( "<span class='badge badge-danger'>요금표</span>" + $("#promotion"+datas.promotion).html() );

    $("#price_input_form").attr('action', "hotelprice" );

    editPriceContents(datas.promotion);

});


/* 요금표 입력 내용 */
window.editPriceContents = function ( promotion ){
    if ( typeof promotion !== "undefined" ) {

        $("#priceContents").html('');

        $.ajax({
            type: 'POST',
            url: "hotelprice/" + promotion,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data) {

                    $("#priceContents").html(data);

                    $('.selectpicker').selectpicker();

                    inputTypeCall();

                    $('#editPrice').modal();
                }
            }
        });
    }
}



/* 요금표 - 공통요금 입력칸 생성 */
window.hotelCommonPriceAdd = function(){
    var hotelCommonPriceAddField = $('#hotelCommonPriceAddField').text();
    hotelCommonPriceAddField = hotelCommonPriceAddField.replace(/{--addID--}/gi, Math.floor(Math.random()*1000000).toString());
    $('#hotelCommonPriceAddArea').append(hotelCommonPriceAddField);
    inputTypeCall();
}







/* 요금표 저장 */
window.savePrice = function (){

    $.ajax({
        type : 'PUT',
        url : $("#price_input_form").attr('action'),
        data : $("#price_input_form").serialize(),
        headers: {
            'X-CSRF-TOKEN': $ ( 'meta[name="csrf-token"]' ).attr ( 'content' )
        },
        success : function (data) {
            if ( data ) {
                //$("#priceContents").html("<div class=\"spinner-border text-primary\"></div>");
                //location.reload();
                editPriceContents(data);
            }
        }
    });
}

